// Traduções de signal_key para texto curto em português, exibidas nas listas de cobrança.
const SIGNAL_KEY_LABELS: Record<string, string> = {
  'sprint.personal_task_status_stale': 'Tarefa parada em sprint',
  'risk.personal_task_overdue': 'Tarefa atrasada',
  'collaboration.personal_unanswered': 'Comentário sem resposta',
  'rushmind.nudge_followup': 'Cobrança em aberto',
}

export function signalKeyLabel(signalKey: string): string {
  return SIGNAL_KEY_LABELS[signalKey] ?? 'Cobrança'
}

// Rótulos das dimensões do score de engajamento (breakdown). Pode vir com 4 ou 5 chaves
// (sprint_hygiene é omitida quando a instância não tem sprint aberta).
const ENGAGEMENT_DIMENSION_LABELS: Record<string, string> = {
  nudge_adherence: 'Adesão a cobranças',
  tasks_on_track: 'Tarefas em dia',
  sprint_hygiene: 'Higiene de sprint',
  time_logging: 'Apontamento de horas',
  milestones_wiki: 'Marcos e wiki',
}

export function engagementDimensionLabel(key: string): string {
  return ENGAGEMENT_DIMENSION_LABELS[key] ?? key
}

// Só vira link se a URL for um caminho interno relativo (ex: /projects/123).
// Bloqueia esquemas perigosos (javascript:, data:) e links "protocol-relative" (//host).
export function isSafeInternalPath(url: string): boolean {
  return /^\/(?!\/)[^\s"'<>]*$/.test(url)
}

// Faixas de cor do score (espelham config/taskrush.php rushmind.engagement_score).
const BAND_GREEN = 70
const BAND_YELLOW = 40

export type EngagementBand = 'green' | 'yellow' | 'red'

export function engagementBand(score: number | null): EngagementBand | null {
  if (score === null || score === undefined) {
    return null
  }
  if (score >= BAND_GREEN) {
    return 'green'
  }
  if (score >= BAND_YELLOW) {
    return 'yellow'
  }
  return 'red'
}
